<template>
  <header :class="$style.header">
    <div :class="$style.logo">
      <img @click="$router.push('/')" src="/icons/logo.svg" alt="" />
    </div>
    <div @keyup.enter="search" :class="$style.search">
      <template v-if="$route.fullPath === '/leads'">
        <img
          @click="search"
          src="/icons/search.svg"
          alt=""
          :class="$style.icon"
        />
        <input type="text" placeholder="Поиск" v-model="searchValue" />
        <img
          v-if="searchValue"
          @click="reset"
          src="/icons/medium-cross.svg"
          alt=""
          :class="$style.reset"
        />
      </template>
    </div>
    <div
      v-if="$route.fullPath === '/leads'"
      @click="$router.push('/new-lead')"
      :class="$style.add"
    >
      <img src="/icons/plus.svg" alt="" />
      Добавить лида
    </div>
    <div
      v-if="$route.fullPath === '/counterparties'"
      @click="$router.push('/new-counterpartie')"
      :class="$style.add"
    >
      <img src="/icons/plus.svg" alt="" />
      Добавить контрагента
    </div>
    <div
      v-if="$route.fullPath === '/projects'"
      @click="$router.push('/new-project')"
      :class="$style.add"
    >
      <img src="/icons/plus.svg" alt="" />
      Добавить проект
    </div>
    <div
      v-if="$route.fullPath === '/events-logs'"
      @click="$router.push('/new-event')"
      :class="$style.add"
    >
      <img src="/icons/plus.svg" alt="" />
      Добавить событие
    </div>
    <!-- <div v-if="!notifications.length" :class="$style.logout">
      <img src="/icons/notification.svg" alt="" />
    </div>
    <div
      v-else
      :class="$style.logout"
      @mouseenter="isNotificationOpen = true"
      @mouseleave="isNotificationOpen = false"
    >
      <img src="/icons/notification-new.svg" alt="" />
      <div :class="$style.amount">
        {{ notifications.filter((i) => !i.is_read).length }}
      </div>
      <div v-if="isNotificationOpen" :class="$style.notifications">
        <div
          v-for="i in notifications"
          :class="{ [$style.notRead]: !i.is_read }"
          :key="i.id"
          @click="open(i)"
        >
          {{ i.message }} <img src="/icons/small-arrow-right.svg" alt="" />
        </div>
      </div>
    </div> -->
    <div @click="logout" :class="$style.logout">
      <img src="/icons/logout.svg" alt="" />
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      searchValue: "",
      isNotificationOpen: false,
      interval: "",
    };
  },
  // async mounted() {
  //   await this.$store.dispatch("getNotifications");
  //   this.interval = setInterval(() => {
  //     this.$store.dispatch("getNotifications");
  //   }, 30000);
  // },
  methods: {
    async logout() {
      await this.$store.dispatch("deleteToken");
      this.$router.push("/login");
    },
    async search() {
      await this.$store.dispatch("getLeads", { search: this.searchValue });
      this.searchValue = "";
    },
    async reset() {
      this.searchValue = "";
      this.$store.dispatch("getLeads", { search: this.searchValue });
    },
    // async open(notification) {
    //   if (!notification.is_read) {
    //     await this.$store.dispatch("readNotification", notification.id);
    //   }
    //   this.$router.push(`/lead/${notification.project}`);
    //   this.isNotificationOpen = false;
    // },
  },
  // computed: {
  //   notifications() {
  //     return this.$store.state.notifications.notifications;
  //   },
  // },
  // beforeUnmount() {
  //   clearInterval(this.interval);
  // },
};
</script>

<style lang="scss" module>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  background-color: $bg-primary;
  gap: 1rem;
  .logo {
    cursor: pointer;
  }
  .search {
    flex: 1 1 auto;
    position: relative;
    .icon {
      position: absolute;
      top: 0.75rem;
      left: 1rem;
      cursor: pointer;
    }
    .reset {
      position: absolute;
      top: 0.75rem;
      right: 1rem;
      cursor: pointer;
    }
    input {
      width: 100%;
      background-color: $bg-secondary;
      outline: 0;
      border: none;
      padding: 1rem 1rem 1rem 3rem;
      border-radius: 6.25rem;
      @include Subtitle;
      color: $t-primary;
      &::placeholder {
        color: $t-secondary;
      }
    }
  }
  .add {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    color: $t-white;
    @include Body2;
    background-color: $main-green;
    border-radius: 6.25rem;
    cursor: pointer;
  }
  .logout {
    cursor: pointer;
    position: relative;
    .amount {
      position: absolute;
      top: 0;
      right: 0;
      color: $t-white;
      width: 1.5rem;
      height: 1.5rem;
      background-color: $red-primary;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      @include Subtitle;
    }
    .notifications {
      position: absolute;
      z-index: 5;
      top: 3.75rem;
      right: 0;
      background-color: $bg-secondary;
      width: 25rem;
      border-radius: 0.5rem;
      border: 1px solid $bg-separator;
      > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 1rem;
        border-bottom: 1px solid $bg-separator;
        @include Body2;
        color: $t-secondary;
        &:last-child {
          border: none;
        }
        &.notRead {
          color: $red-primary;
        }
      }
    }
  }
}
</style>
